import { render, staticRenderFns } from "./MenuWrapper.vue?vue&type=template&id=a7dc4742&scoped=true&"
import script from "./MenuWrapper.vue?vue&type=script&lang=js&"
export * from "./MenuWrapper.vue?vue&type=script&lang=js&"
import style0 from "./MenuWrapper.vue?vue&type=style&index=0&id=a7dc4742&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7dc4742",
  null
  
)

export default component.exports